export const SET_VENTURE_BOOSTER_CONTRACT =
  "CONTRACTS://SET_VENTURE_BOOSTER_CONTRACT";
